<template>
	<div style="position: relative;width: 100%;">
		<!-- 搜索过滤区域 -->
		<div style="padding: 1.4% 2%;background-color: #fff;">
			<el-form :inline="true">
				<el-form-item label="创建时间">
					<!-- 
                      关键修改说明：
                      1. value-format="YYYY-MM-DD HH:mm:ss": 
                         确保 v-model 绑定的是格式化后的字符串数组，而非 Date 对象数组，方便后端接收。
                      2. :default-time: 
                         设置选择日期时的默认具体时间（开始为00:00:00，结束为23:59:59）。
                    -->
					<el-date-picker v-model="queryForm.queryTime" type="datetimerange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD HH:mm:ss"
						:default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="搜索内容">
					<!-- @change 事件在输入框失去焦点或按下回车时触发查询 -->
					<el-input style="width: 15vw;position: relative;" @change="getOrderList()" v-model="queryForm.q"
						clearable placeholder="支持运单号、姓名、电话、地址搜索" maxlength="20" show-word-limit link
						type="primary"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getOrderList()">查询</el-button>
					<!-- 批量打印按钮：当没有选中任何订单时禁用 -->
					<el-button type="primary" plain @click="batchPrint()"
						:disabled="selectedOrders.length == 0">批量打印（{{selectedOrders.length}}）</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 数据表格区域 -->
		<div style="margin-top: 1vh;background-color: #fff;padding: 2%;font-family: sans-serif;color: #444444;">
			<!-- 
				ref="orderTable": 用于获取表格实例，以便调用 toggleRowSelection 等方法
				@selection-change: 当选择项发生变化时会触发该事件
				:selectable: 用于判断某一行是否可以被勾选
			-->
			<el-table :data="queryOrderList.orderList" height="74vh" style="z-index: 2;" ref="orderTable"
				@selection-change="handleSelectionChange"
				:header-cell-style="{background:'#f4f4f5',color:'#3b3b3b','font-weight': 400}" v-loading="loading"
				element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">

				<!-- 多选列 -->
				<el-table-column type="selection" width="45" align="center" :selectable="isPrintable"></el-table-column>

				<el-table-column prop="creationTime" label="创建时间" align="center" width="107"></el-table-column>

				<el-table-column prop="waybillNo" label="运单号" align="center">
					<template #default="scope">
						<div style="display: flex;align-items: center;">
							<!-- 点击运单号查询物流轨迹 -->
							<div @click="waybillQueryPopup({cpCode: scope.row.cpCode,waybillNo: scope.row.waybillNo,phone: scope.row.sender.mobile})"
								style="color: #409EFF;cursor: pointer;">
								{{scope.row.waybillNo}}
							</div>
							<!-- 复制运单号图标 -->
							<el-icon v-if="scope.row.waybillNo" @click="common.copy(scope.row.waybillNo)"
								style="left: 0.7em;">
								<CopyDocument />
							</el-icon>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="orderStatusText" label="订单状态" align="center"></el-table-column>

				<el-table-column prop="waybillLatestStatusName" label="物流状态" align="center">
					<template #default="scope">
						<div v-if="scope.row.waybillLatestStatusName">{{scope.row.waybillLatestStatusName}}</div>
						<div v-else>未发出</div>
					</template>
				</el-table-column>

				<!-- 发件人信息列 -->
				<el-table-column prop="sender" label="发件信息" width="240" align="left" header-align="left">
					<template #default="scope">
						<div>
							{{scope.row.sender.name}}{{"&nbsp;&nbsp;"}}
							<span v-if="scope.row.sender.mobile">{{scope.row.sender.mobile}}</span>
							<span v-else>{{scope.row.sender.phone}}</span>
						</div>
						<!-- 地址过长时显示省略号 -->
						<div
							style="overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:1; ">
							{{scope.row.sender.provinceName}}{{scope.row.sender.cityName}}{{scope.row.sender.districtName}}{{scope.row.sender.address}}
						</div>
					</template>
				</el-table-column>

				<!-- 收件人信息列 -->
				<el-table-column prop="recipient" label="收件信息" width="240" align="left" header-align="left">
					<template #default="scope">
						<div>
							{{scope.row.recipient.name}}{{"&nbsp;&nbsp;"}}
							<span v-if="scope.row.recipient.mobile">{{scope.row.recipient.mobile}}</span>
							<span v-else>{{scope.row.recipient.phone}}</span>
						</div>
						<div
							style="overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:1; ">
							{{scope.row.recipient.provinceName}}{{scope.row.recipient.cityName}}{{scope.row.recipient.districtName}}{{scope.row.recipient.address}}
						</div>
					</template>
				</el-table-column>

				<!-- 操作列 -->
				<el-table-column fixed="right" label="操作" align="center">
					<template #default="scope">
						<el-button @click="see(scope.row)" link type="primary">查看</el-button>
						<!-- 只有状态为 CREATE (已创建) 时才显示“打印” -->
						<el-button v-if="scope.row.orderStatusCode == 'CREATE'"
							@click="waybillPrintPopup({orderContent:scope.row,isReprint:false})" link
							type="primary">打印</el-button>
						<!-- 状态为 GET_WAYBILL 或 PRINT 时显示“重新打印” -->
						<el-button v-if="['GET_WAYBILL','PRINT'].includes(scope.row.orderStatusCode)"
							@click="waybillPrintPopup({orderContent:scope.row,isReprint:true})" link
							type="primary">重新打印</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页组件 -->
			<el-pagination @size-change="handleSizeChange($event)" @current-change="handleCurrentChange($event)"
				:page-sizes="[20,50,100,200]" :total="queryOrderList.total" v-model:current-page="queryForm.pages"
				v-model:page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</div>

		<!-- 订单详情弹窗 (手动实现的 Modal) -->
		<div v-if="order_info_window" class="order-info scroll-bar">
			<!-- 遮罩层 -->
			<div @click="order_info_window=false"
				style="position: fixed;width: 100%;height: 100%;background-color: rgb(20 20 20);left: 0%;top: 0;opacity: 0.7;z-index: 6;">
			</div>
			<!-- 弹窗内容主体 -->
			<div
				style="position: fixed;width:60%;height: 85%;background-color: #ffffff;z-index: 7;top: 6%;left: 21%;border-radius: 0.3em;">
				<!-- 关闭按钮 -->
				<div @click="order_info_window=false"
					style="position: absolute;right: 2%;top: 1.6%;font-size: 1.4em;color: #7f8186;z-index: 2;">
					<el-icon size="1.4em">
						<Close />
					</el-icon>
				</div>
				<!-- 可滚动内容区域 -->
				<div class="scroll-bar"
					style="position: relative;width:92%;height: 90%;margin: 5% 0 1% 5%;overflow-y: auto;">

					<!-- 订单基本信息块 -->
					<div>
						<div class="block-header">
							<div>订单信息</div>
						</div>
						<div class="block-data">
							<div class="block-data-row">
								<div class="row-name">运单号：</div>
								<div class="row-data">
									<span v-if="orderInfo.cpName && orderInfo.cpName!='未知品牌'"
										style="margin-right: 1rem;">{{orderInfo.cpName}}</span>
									<span @click="$commonFunction.toQueryWaybill(orderInfo.waybillNo)"
										v-if="orderInfo.waybillNo"
										style="cursor:pointer;color: #409EFF;margin-right: 1rem;">{{orderInfo.waybillNo}}</span>
									<span v-else>未获取</span>
									<span v-show="orderInfo.previewImageUrl"><a :href="orderInfo.previewImageUrl"
											target="_blank" style="color: #409EFF;text-decoration:none;">查看面单</a></span>
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">发件人：</div>
								<div class="row-data">
									{{orderInfo.sender.name}}{{"&nbsp;&nbsp;"}}{{orderInfo.sender.mobile}}{{orderInfo.sender.phone}}{{"&nbsp;&nbsp;"}}{{orderInfo.sender.provinceName}}{{orderInfo.sender.cityName}}{{orderInfo.sender.districtName}}{{orderInfo.sender.address}}
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">收件人：</div>
								<div class="row-data">
									{{orderInfo.recipient.name}}{{"&nbsp;&nbsp;"}}{{orderInfo.recipient.mobile}}{{orderInfo.recipient.phone}}{{"&nbsp;&nbsp;"}}{{orderInfo.recipient.provinceName}}{{orderInfo.recipient.cityName}}{{orderInfo.recipient.districtName}}{{orderInfo.recipient.address}}
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">物品名称：</div>
								<div v-if="orderInfo.goods.length>0" class="row-data">{{orderInfo.goods[0].name}}</div>
								<div v-else class="row-data">未定义</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">物品重量：</div>
								<div v-if="orderInfo.goods.length>0" class="row-data">
									<span>{{orderInfo.goods[0].weight}}</span>
									<span v-if="orderInfo.goods[0].weight">公斤</span>
								</div>
								<div v-else class="row-data">未定义</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">备注：</div>
								<div class="row-data">{{orderInfo.remark}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">实名采集：</div>
								<div class="row-data">暂不支持</div>
							</div>
						</div>
					</div>

					<!-- 增值服务块 -->
					<div v-if="orderInfo.service.length>0">
						<el-divider></el-divider>
						<div class="block-header">
							<div>增值服务</div>
						</div>
						<div class="block-data">
						</div>
					</div>

					<!-- 包裹照片块 -->
					<div v-if="orderInfo.goodsImageList.length>0">
						<el-divider></el-divider>
						<div class="block-header">
							<div>包裹照片</div>
						</div>
						<div class="block-data">

						</div>
					</div>

					<!-- 其他信息块 -->
					<div>
						<el-divider></el-divider>
						<div class="block-header">
							<div>其他信息</div>
						</div>
						<div class="block-data">
							<div class="block-data-row">
								<div class="row-name">订单状态：</div>
								<div class="row-data">{{orderInfo.orderStatusText}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">订单编号：</div>
								<div class="row-data">{{orderInfo.orderNo}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">创建时间：</div>
								<div class="row-data">{{orderInfo.creationTime}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">订单来源：</div>
								<div class="row-data"></div>
							</div>
						</div>
					</div>
					<el-divider></el-divider>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	// 引入 dayjs 用于时间处理
	import dayjs from 'dayjs';

	export default {
		data() {
			return {
				// 查询结果数据
				queryOrderList: {
					orderList: [],
					total: 0
				},

				// 控制订单详情弹窗显示
				order_info_window: false,
				// 当前查看的订单详情数据
				orderInfo: {
					sender: {},
					recipient: {}
				},
				// 查询表单参数
				queryForm: {
					waybillNo: "",
					q: "",
					queryTime: [], // 初始为空数组，由 initDefaultTime 初始化
					cpCode: "",
					pages: 1,
					pageSize: 10,
				},
				// 当前页勾选的订单列表
				selectedOrders: [],
				queryWindow: false,
				// 新增：控制表格加载状态的变量
				loading: false
			}
		},
		created() {
			// 组件创建时初始化默认时间并加载数据
			this.initDefaultTime();
			this.getOrderList();
		},
		methods: {
			// 初始化默认查询时间为最近30天
			initDefaultTime() {
				try {
					// 使用 dayjs 获取最近30天的时间，并格式化为字符串
					const endDate = dayjs().endOf('day');
					const startDate = dayjs().subtract(30, 'day').startOf('day');

					this.queryForm.queryTime = [
						startDate.format('YYYY-MM-DD HH:mm:ss'),
						endDate.format('YYYY-MM-DD HH:mm:ss')
					];
				} catch (e) {
					console.error("时间初始化失败", e);
					// 降级处理：如果 dayjs 不可用，使用原生 JS
					const now = new Date();
					const start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

					const fmt = (d) => {
						const pad = (n) => n < 10 ? '0' + n : n;
						return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
					};

					this.queryForm.queryTime = [fmt(start), fmt(now)];
				}
			},

			// 分页：每页显示数量变化
			handleSizeChange(size) {
				this.queryForm.pageSize = size;
				this.getOrderList()
			},
			// 分页：页码变化
			handleCurrentChange(pages) {
				this.queryForm.pages = pages;
				this.getOrderList()
			},
			// 表格多选：更新选中的订单列表
			handleSelectionChange(selection) {
				this.selectedOrders = selection;
			},
			// 判断行是否允许勾选：只有特定状态的订单才允许勾选用于打印
			isPrintable(row) {
				return ['CREATE', 'GET_WAYBILL', 'PRINT'].includes(row.orderStatusCode);
			},
			// 批量打印：检查是否有选中项，然后调用打印弹窗
			batchPrint() {
				if (!this.selectedOrders.length) {
					this.$message.warning('请先勾选需要打印的订单');
					return;
				}
				// 传入选中的订单列表，启用批量模式
				this.waybillPrintPopup({
					orderList: this.selectedOrders
				});
			},
			// 查看订单详情：打开弹窗并赋值数据
			see(data) {
				if (data) {
					this.order_info_window = true;
					console.log(data);
					// 将当前行数据复制到 orderInfo 对象中用于展示
					Object.assign(this.orderInfo, data);
				} else {
					this.$message.error('订单详情不存在');
				}
			},
			// 获取订单列表：调用后端接口
			getOrderList() {
				// 1. 开启加载
				this.loading = true;
				// 重置列表数据，防止旧数据闪烁
				this.queryOrderList = {
					orderList: [],
					total: 0
				};
				// 注意：这里没有重置 pages，因为如果是分页切换触发的，需要保留页码
				// 如果是搜索触发的，建议在搜索按钮点击事件中重置 pages=1

				console.log("查询参数:", this.queryForm);

				// 假设 apiService 是全局注入或 mixin 提供的服务
				this.apiService.post({
						modules: "getOrderList",
						content: this.queryForm
					})
					.then((res) => {
						if (res.status) {
							this.queryOrderList = res.data;
							console.log(this.queryOrderList)
						}
					})
					.catch((err) => {
						console.error("获取列表失败", err);
					})
					.finally(() => {
						// 2. 无论成功或失败，都关闭加载
						this.loading = false;
					});
			},
			// 占位方法：实际项目中应实现具体的业务逻辑
			/* waybillQueryPopup(params) {
				console.log("查询物流", params);
			},
			waybillPrintPopup(params) {
				console.log("打印面单", params);
			} */
		}
	}
</script>

<style scoped>
	/* 弹窗基础样式 */
	.order-info {
		font-family: sans-serif;
	}

	/* 区块标题样式 */
	.order-info .block-header {
		font-weight: 600;
		margin-bottom: 1rem;
	}

	/* 详情行样式 */
	.order-info .block-data-row {
		display: flex;
		margin-top: 0.6rem;
	}

	/* 标签名称样式 */
	.order-info .block-data-row .row-name {
		color: #8f8e8ef2;
		width: 10%;
		position: relative;
	}

	/* 自定义滚动条样式 */
	.scroll-bar::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.scroll-bar::-webkit-scrollbar-thumb {
		background: #ccc;
		border-radius: 3px;
	}
</style>